import { usePageMeta } from "@/lib/pageMeta";

export const PrivacyPage = () => {
    usePageMeta({
        title: "Política de Privacidade e Termos de Serviço",
        description: "Política de Privacidade e Termos de Serviço da Rock Fox Studio. Em vigor desde 6 de agosto de 2026.",
        path: "/politica-de-privacidade",
    });

    return (
        <section className="bg-paper px-6 py-[90px] md:px-[90px]">
            <article className="mx-auto max-w-[760px] text-ink">
                <header className="border-b border-ink/10 pb-8">
                    <h1 className="type-display text-[clamp(32px,4vw,52px)] leading-[1.05] text-brand">
                        Política de Privacidade e Termos de Serviço
                    </h1>
                    <p className="mt-4 text-[15px] font-semibold text-ink/80">
                        Em vigor desde 6 de agosto de 2026
                    </p>
                </header>

                <div className="mt-10 space-y-12 text-[16px] leading-relaxed text-ink/90">
                    {/* 1. Quem somos */}
                    <section>
                        <h2 className="type-display text-[clamp(20px,2.2vw,28px)] text-ink">
                            1. Quem somos
                        </h2>
                        <p className="mt-3">
                            ROCK FOX STUDIO é um estúdio de branding e design especializado em identidade visual, estratégia de redes sociais e design sob demanda.
                        </p>
                        <p className="mt-3">
                            Para qualquer questão sobre privacidade, serviços ou contrato, o contato é{" "}
                            <a href="mailto:adm@rockfoxstudio.com" className="font-semibold text-brand underline decoration-brand/40 underline-offset-4 hover:decoration-brand">
                                adm@rockfoxstudio.com
                            </a>.
                        </p>
                    </section>

                    <hr className="border-ink/10" />

                    {/* 2. O que não coletamos */}
                    <section>
                        <h2 className="type-display text-[clamp(20px,2.2vw,28px)] text-ink">
                            2. O que não coletamos
                        </h2>
                        <p className="mt-3">
                            Este site não possui cadastro, não usa cookies próprios e não executa ferramentas de análise, rastreamento ou gravação de sessão. Não construímos perfis de navegação e não vendemos nem compartilhamos dados com anunciantes.
                        </p>
                    </section>

                    <hr className="border-ink/10" />

                    {/* 3. Dados de contato e formulário */}
                    <section>
                        <h2 className="type-display text-[clamp(20px,2.2vw,28px)] text-ink">
                            3. Dados de contato e formulário
                        </h2>
                        <p className="mt-3">
                            O formulário da página de contato não envia dados para este site. Ao concluir, as informações que você digitou são reunidas em um E-mail, no seu próprio dispositivo, e você decide se envia.
                        </p>
                        <p className="mt-3">
                            A partir do envio, a conversa passa a ser tratada pelo e-mail, sob a política de privacidade do Google. Usamos o conteúdo apenas para responder ao seu contato e elaborar propostas de trabalho.
                        </p>
                    </section>

                    <hr className="border-ink/10" />

                    {/* 4. Serviços e responsabilidades */}
                    <section className="space-y-8">
                        <div>
                            <h2 className="type-display text-[clamp(20px,2.2vw,28px)] text-ink">
                                4. Serviços e responsabilidades
                            </h2>
                        </div>

                        {/* 4.1 Geral para todos os serviços */}
                        <div className="space-y-5">
                            <h3 className="type-display text-[clamp(18px,1.8vw,22px)] text-brand">
                                4.1 Geral para todos os serviços
                            </h3>

                            <div>
                                <h4 className="font-bold text-ink">Requisitos de entrada:</h4>
                                <p className="mt-1">Para iniciar qualquer projeto, o cliente deve fornecer:</p>
                                <ul className="mt-2 list-disc space-y-1.5 pl-6">
                                    <li>Logos (nas cores da marca, preto e branco) em PNG e PDF</li>
                                    <li>Códigos de cores (RGB, HEX, CMYK)</li>
                                    <li>Manual de Marca em PDF</li>
                                    <li>Arquivos de fontes utilizadas (TTF, OTF ou similares)</li>
                                </ul>
                                <p className="mt-2 text-ink/75">
                                    Caso não tenha, deve ser sinalizado e acordado com a Rock Fox Studio.
                                </p>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Revisões e ajustes:</h4>
                                <ul className="mt-2 list-disc space-y-1.5 pl-6">
                                    <li>Cada arte ou material inclui <strong>até 2 rodadas de revisão</strong></li>
                                    <li>Revisões adicionais serão cobradas à parte</li>
                                    <li>Revisões são consideradas qualquer alteração solicitada pelo cliente após a primeira entrega</li>
                                </ul>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Direitos autorais e uso:</h4>
                                <ul className="mt-2 list-disc space-y-1.5 pl-6">
                                    <li>A Rock Fox é proprietária dos arquivos finalizados entregues, o cliente tem direitos comerciais e de divulgação.</li>
                                    <li>Autoriza o uso do trabalho em portfólio da ROCK FOX STUDIO e do designer/criativo responsável</li>
                                    <li>Pode usar os materiais para fins de divulgação e comercial, sem restrições geográficas ou temporais</li>
                                </ul>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Prazos:</h4>
                                <ul className="mt-2 list-disc space-y-1.5 pl-6">
                                    <li>Prazos são combinados individualmente por projeto</li>
                                    <li>Atrasos na entrega de briefing, aprovações ou materiais pelo cliente <strong>estendem automaticamente o prazo de entrega</strong></li>
                                </ul>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Garantias e resultados:</h4>
                                <ul className="mt-2 list-disc space-y-1.5 pl-6">
                                    <li>A ROCK FOX STUDIO não garante crescimento, engajamento, vendas ou qualquer resultado comercial específico</li>
                                    <li>Nos responsabilizamos pela qualidade criativa e técnica do trabalho entregue, não pelos resultados que ele gera</li>
                                    <li>Suporte técnico pós-entrega (dúvidas sobre arquivos, compatibilidade, etc.) não é incluído. O cliente é responsável por garantir que possui os softwares necessários para abrir e editar os arquivos recebidos</li>
                                </ul>
                            </div>
                        </div>

                        {/* 4.2 Identidade Visual */}
                        <div className="space-y-4 pt-4">
                            <h3 className="type-display text-[clamp(18px,1.8vw,22px)] text-brand">
                                4.2 Identidade Visual (criação do zero ou rebranding)
                            </h3>

                            <div>
                                <h4 className="font-bold text-ink">Processo:</h4>
                                <ol className="mt-2 list-decimal space-y-1.5 pl-6">
                                    <li><strong>Após aceite da proposta</strong>, enviamos formulário de briefing para o cliente</li>
                                    <li><strong>Reunião de alinhamento</strong>: máximo 1h30 para revisar informações, validar direcionamentos e esclarecer dúvidas</li>
                                    <li><strong>Desenvolvimento</strong>: prazo combinado entre as partes</li>
                                    <li><strong>Entrega</strong>: 2 rodadas de revisão incluídas</li>
                                </ol>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Para rebranding especificamente:</h4>
                                <p className="mt-1 text-ink/85">
                                    Cliente deve fornecer todos os materiais atuais da marca (logos, manual, cores, arquivos de fontes — confira a seção 4.1).
                                </p>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Formatos de entrega:</h4>
                                <ul className="mt-2 list-disc space-y-1.5 pl-6">
                                    <li>Logo finalizado em <strong>PDF (vetor)</strong></li>
                                    <li>Logo aberto/editável em <strong>PSD</strong></li>
                                    <li>Exportações em <strong>PNG 300dpi</strong> (cores da marca, preto, branco)</li>
                                    <li>Manual de marca em <strong>PDF</strong></li>
                                    <li>Todos os arquivos de fonte utilizados</li>
                                </ul>
                            </div>
                        </div>

                        {/* 4.3 Brand Care */}
                        <div className="space-y-4 pt-4">
                            <h3 className="type-display text-[clamp(18px,1.8vw,22px)] text-brand">
                                4.3 Brand Care (gestão visual contínua)
                            </h3>

                            <div>
                                <h4 className="font-bold text-ink">O que fazemos:</h4>
                                <p className="mt-1">
                                    Assumimos o controle total da <strong>divulgação visual</strong> da marca nas redes sociais: criação de artes, textos visuais, vídeos, sons, efeitos, legendas e toda gestão visual de conteúdo.
                                </p>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">O que NÃO fazemos:</h4>
                                <ul className="mt-2 list-disc space-y-1.5 pl-6">
                                    <li>Não respondemos comentários, mensagens diretas ou críticas/elogios de seguidores</li>
                                    <li>Não gerenciamos a estratégia comercial ou relacionamento com o público</li>
                                </ul>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Entrega:</h4>
                                <p className="mt-1">
                                    A ROCK FOX STUDIO realiza a postagem dos conteúdos nas redes sociais. O cliente recebe os materiais para validação antes do agendamento/publicação.
                                </p>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Duração mínima:</h4>
                                <p className="mt-1">
                                    Serviço oferecido mediante contrato específico com período mínimo de 6 meses.
                                </p>
                            </div>
                        </div>

                        {/* 4.4 PackPost */}
                        <div className="space-y-4 pt-4">
                            <h3 className="type-display text-[clamp(18px,1.8vw,22px)] text-brand">
                                4.4 PackPost (pacotes de postagens)
                            </h3>

                            <div>
                                <h4 className="font-bold text-ink">O que é:</h4>
                                <p className="mt-1">
                                    Pacotes fechados de postagens com direcionamentos estratégicos fornecidos pelo cliente.
                                </p>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Processo:</h4>
                                <ol className="mt-2 list-decimal space-y-1.5 pl-6">
                                    <li><strong>Formulário de briefing</strong> é enviado ao cliente</li>
                                    <li>
                                        <strong>Cliente fornece:</strong>
                                        <ul className="mt-1 list-disc space-y-1 pl-6">
                                            <li>Direcionamentos estratégicos (objetivos de cada post, textos para artes, direção criativa)</li>
                                            <li>Materiais de marca: logos em PDF/PNG/PSD, código de cores, manual da marca</li>
                                        </ul>
                                    </li>
                                    <li><strong>Desenvolvimento</strong> conforme prazo combinado</li>
                                    <li><strong>Entrega</strong>: até 2 rodadas de revisão por arte</li>
                                </ol>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Formatos de entrega:</h4>
                                <ul className="mt-2 list-disc space-y-1.5 pl-6">
                                    <li>Artes finalizadas em <strong>JPG</strong></li>
                                    <li>Textos e legendas em documento separado</li>
                                </ul>
                            </div>
                        </div>

                        {/* 4.5 Design On Demand */}
                        <div className="space-y-4 pt-4">
                            <h3 className="type-display text-[clamp(18px,1.8vw,22px)] text-brand">
                                4.5 Design On Demand (designs unitários ou pontuais)
                            </h3>

                            <div>
                                <h4 className="font-bold text-ink">O que é:</h4>
                                <p className="mt-1">
                                    Criação de designs específicos (materiais digitais e/ou físicos) conforme demanda do cliente.
                                </p>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Processo:</h4>
                                <ol className="mt-2 list-decimal space-y-1.5 pl-6">
                                    <li><strong>Formulário de briefing</strong> é enviado ao cliente</li>
                                    <li>
                                        <strong>Cliente fornece:</strong>
                                        <ul className="mt-1 list-disc space-y-1 pl-6">
                                            <li>Descrição do design, objetivo e especificações técnicas</li>
                                            <li>Materiais de marca (logos, cores, fontes — confira seção 4.1)</li>
                                        </ul>
                                    </li>
                                    <li><strong>Desenvolvimento</strong> conforme prazo combinado</li>
                                    <li><strong>Entrega</strong>: até 2 rodadas de revisão</li>
                                </ol>
                            </div>

                            <div>
                                <h4 className="font-bold text-ink">Formatos de entrega:</h4>
                                <ul className="mt-2 list-disc space-y-1.5 pl-6">
                                    <li>Se digital: JPG</li>
                                    <li>Se para impressão: PDF em cores (CMYK) e PSD</li>
                                    <li>Arquivos abertos em <strong>PSD</strong></li>
                                </ul>
                            </div>
                        </div>
                    </section>

                    <hr className="border-ink/10" />

                    {/* 5. Serviços de terceiros */}
                    <section className="space-y-4">
                        <h2 className="type-display text-[clamp(20px,2.2vw,28px)] text-ink">
                            5. Serviços de terceiros
                        </h2>
                        <p>
                            <strong>Google Fonts:</strong> As fontes deste site são carregadas do Google Fonts. Para entregá-las, o Google recebe o endereço IP do seu dispositivo.
                        </p>
                        <p>
                            <strong>Netlify (hospedagem):</strong> A hospedagem é feita pela Netlify, que mantém registros técnicos de acesso — como endereço IP, horário de acesso e tipo de navegador — para operar e proteger o serviço.
                        </p>
                        <p>
                            <strong>E-mail:</strong> Comunicação com o cliente passa pelo E-mail, sob a política de privacidade do Google.
                        </p>
                    </section>

                    <hr className="border-ink/10" />

                    {/* 6. Modificações e contratação adicional */}
                    <section className="space-y-3">
                        <h2 className="type-display text-[clamp(20px,2.2vw,28px)] text-ink">
                            6. Modificações e contratação adicional
                        </h2>
                        <p>
                            Se o cliente solicita alterações nos materiais <strong>após a entrega final</strong> (fora das 2 rodadas de revisão incluídas), isso é considerado um <strong>novo trabalho</strong> e será cotado à parte.
                        </p>
                        <p>
                            Alterações durante o desenvolvimento (dentro das 2 rodadas) não geram custo adicional.
                        </p>
                    </section>

                    <hr className="border-ink/10" />

                    {/* 7. Seus direitos conforme LGPD */}
                    <section className="space-y-3">
                        <h2 className="type-display text-[clamp(20px,2.2vw,28px)] text-ink">
                            7. Seus direitos conforme LGPD
                        </h2>
                        <p>Pela Lei Geral de Proteção de Dados (LGPD), você pode solicitar:</p>
                        <ul className="list-disc space-y-1.5 pl-6">
                            <li>Confirmação de tratamento de dados</li>
                            <li>Acesso aos seus dados</li>
                            <li>Correção ou anonimização</li>
                            <li>Portabilidade</li>
                            <li>Eliminação dos seus dados</li>
                            <li>Revogação de consentimento</li>
                        </ul>
                        <p className="mt-3">
                            Para exercer qualquer um desses direitos, escreva para{" "}
                            <a href="mailto:adm@rockfoxstudio.com" className="font-semibold text-brand underline decoration-brand/40 underline-offset-4 hover:decoration-brand">
                                adm@rockfoxstudio.com
                            </a>.
                        </p>
                    </section>

                    <hr className="border-ink/10" />

                    {/* 8. Alterações desta política */}
                    <section className="space-y-3">
                        <h2 className="type-display text-[clamp(20px,2.2vw,28px)] text-ink">
                            8. Alterações desta política
                        </h2>
                        <p>
                            Se o funcionamento do site ou nossos serviços mudarem, esta política será atualizada e a data de revisão abaixo será alterada.
                        </p>
                        <p className="font-semibold text-ink">
                            Versão atual: 08 de Setembro de 2026
                        </p>
                    </section>

                    <hr className="border-ink/10" />

                    {/* Contato */}
                    <section className="space-y-2">
                        <h2 className="type-display text-[clamp(20px,2.2vw,28px)] text-ink">
                            Contato
                        </h2>
                        <p>
                            <strong>E-mail:</strong>{" "}
                            <a href="mailto:adm@rockfoxstudio.com" className="text-brand underline decoration-brand/40 underline-offset-4 hover:decoration-brand">
                                adm@rockfoxstudio.com
                            </a>
                        </p>
                    </section>
                </div>
            </article>
        </section>
    );
};
